import dayjs from "dayjs";
import { getHistories, getHistoryDetails } from "../api/historyApi";

export interface OrderHistoryModel {
  orderUuid: string;
  orderId: string;
  paymentStatus: "paid" | "pending" | "failed" | string;
  paymentRef: string;
  amount: number; // normalize to number
  paymentChannel: string;
  paymentChannelId: string;
  orderDate: string; // ISO
  monthKey: string; // "YYYY-MM" (for grouping)
}

export interface OrderWithHistoryDetailModel {
  orderId: string; // for display;
  paymentStatus: string;
  paymentRef: string;
  amount: string;
  paymentChannel: string;
  orderDate: string;
  customerName: string;
  orderDetails: OrderHistoryDetaiModel[];
}

export interface OrderHistoryDetaiModel {
  packageName: string;
  msisdn: string;
  dataQuota: string;
  voiceQuota: string;
  dayQuota: string;
  price: string;
  areaService: string;
  esimQR: string;
}

export const fetchOrderHistories = async (
  cusId: string
): Promise<OrderHistoryModel[]> => {
  const res = await getHistories(cusId);
  return res.data.map((h: any) => {
    const orderDate = h.created_at;
    return {
      orderUuid: h.uuid,
      orderId: h.order_id,
      paymentStatus: (h.payment_status ?? "").toLowerCase(),
      paymentRef: h.payment_ref,
      amount: Number(h.amount ?? 0),
      paymentChannel: h.payment_channel,
      paymentChannelId: h.payment_channel_id,
      orderDate,
      monthKey: dayjs(orderDate).isValid()
        ? dayjs(orderDate).format("YYYY-MM")
        : "unknown",
    };
  });
};

export const fetchOrderHistoryDetails = async (
  orderUuid: string,
  channelId: string
): Promise<OrderWithHistoryDetailModel> => {
  const res = await getHistoryDetails(orderUuid, channelId);
  const orderHistory = res.data;
  return {
    orderId: orderHistory.order_id, // for display;
    paymentStatus: orderHistory.payment_status,
    paymentRef: orderHistory.payment_ref,
    amount: orderHistory.total_amount,
    paymentChannel: orderHistory.payment_channel,
    orderDate: orderHistory.created_at,
    customerName: orderHistory.customer_name,
    orderDetails: orderHistory.details.map((orderDetail) => ({
      packageName: orderDetail.package_name,
      msisdn: orderDetail.msisdn,
      dataQuota: orderDetail.package_quota,
      voiceQuota: orderDetail.voice_quota,
      dayQuota: orderDetail.day_quota,
      price: orderDetail.price,
      areaService: orderDetail.area,
      esimQR: orderDetail.imge,
    })),
  };
};
